import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/home/Home.vue'

// 解决重复跳转到当前路由报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/', // 首页
    name: 'home',
    component: Home,
  },
  {
    path: '/signin', // 用户登录
    name: 'signin',
    component: () => import(/* webpackChunkName: "" */ '@/views/sign/SignIn'),
  },
  {
    path: '/register', // 用户注册
    name: 'register',
    component: () => import('@/views/sign/Register'),
  },
  {
    path: '/forgetPassword', // 忘记密码
    name: 'forgetPassword',
    component: () => import('@/views/sign/ForgetPassword'),
  },
  {
    path: '/transaction/:tradingPair?/:coinId?', // 交易中心
    name: 'transaction',
    component: () => import('@/views/transaction/CurrencyTransaction.vue'),
  },
  {
    path: '/market', // 行情页面
    name: 'market',
    component: () => import('@/views/market/MarketPage'),
  },
  {
    path: '/buyingSelling', // 买卖盘页面
    name: 'buyingSelling',
    component: () => import('@/views/transaction/BuyingSelling'),
  },
  // {
  //   path: '/currentHistory/:tab?', // 当前委托、历史委托
  //   name: 'currentHistory',
  //   component: () => import('@/views/transaction/CurrentHistyory')
  // },
  {
    path: '/notice', // 公告中心
    name: 'notice',
    component: () => import('@/views/notice/NoticePage'),
  },
  {
    path: '/noticeDetail', // 公告详情
    name: 'noticeDetail',
    component: () => import('@/views/notice/NoticeDetail'),
  },
  {
    path: '/inviteFriends', // 邀请好友
    name: 'inviteFriends',
    component: () => import('@/views/invite/InviteFriend'),
  },
  // {
  //   path: '/financialRecords/:coinId', // 财务记录
  //   name: 'financialRecords',
  //   component: () => import('@/views/asset/FinancialRecords')
  // },
  // {
  //   path: '/lockDelay/:tag', // 活动锁仓、延迟奖金
  //   name: 'lockDelay',
  //   component: () => import('@/views/asset/LockDelay')
  // },
  // {
  //   path: '/download', // 下载页面
  //   name: 'download',
  //   component: () => import('@/views/download/Download')
  // },
  {
    path: '/personal', // 个人信息
    name: 'personal',
    component: () => import('@/views/personal/Personal'),
  },
  {
    path: '/securitylog', // 安全记录页面
    name: 'securitylog',
    component: () => import('@/views/personal/SecurityLog'),
  },
  {
    path: '/identity', // 身份验证
    name: 'identity',
    component: () => import('@/views/personal/Identity'),
  },
  {
    path: '/KYCAuth/:authLevel', // KYC认证
    name: 'KYCAuth',
    component: () => import('@/views/personal/KYCAuth'),
  },
  {
    path: '/mentionmoney', // 提币页面
    name: 'mentionmoney',
    component: () => import('@/views/personal/MentionMoney'),
  },
  // {
  //   path: '/addressbook',
  //   name: 'addressbook',
  //   component: () => import('@/views/personal/AddressBook')
  // },
  {
    path: '/myassets', // 我的资产
    name: 'myassets',
    component: () => import('@/views/personal/MyAssets'),
  },
  // {
  //   path: '/subscription', // 认购
  //   name: 'subscription',
  //   component: () => import('@/views/personal/Subscription')
  // },
  // {
  //   path: '/subscription/detail/:id', // 认购详情
  //   name: 'subscriptionDetail',
  //   component: () => import('@/views/personal/SubscriptionDetail')
  // },
  // {
  //   path: '/subscription/particulars/:id', // 认购明细
  //   name: 'particulars',
  //   component: () => import('@/views/personal/SubParticulars')
  // },
  {
    path: '/recharge', // 充币
    name: 'recharge',
    component: () => import('@/views/personal/Recharge'),
  },
  {
    path: '/notcertified/:type', // 身份未认证 or 资金密码未设置
    name: 'notcertified',
    component: () => import('@/views/personal/NotCertified'),
  },
  {
    path: '/contract', // 合约
    name: 'contract',
    component: () => import('@/views/contract/index'),
  },
  {
    path: '/position', // 持仓
    name: 'position',
    component: () => import('@/views/position/index'),
  },
  {
    path: '/history', // 持仓历史记录
    name: 'history',
    component: () => import('@/views/position/history'),
  },
  {
    path: '/transfer/:currency?', // 持仓历史记录
    name: 'transfer',
    component: () => import('@/views/transfer/index'),
  },
  // {
  //   path: '/bill', // 账单
  //   name: 'bill',
  //   component: () => import('@/views/personal/Bill')
  // },
  // {
  //   path: '/agreement/:id', // 服务条款 和 隐私政策与声明
  //   name: 'agreement',
  //   component: () => import('@/views/sign/Agreement')
  // },
  // {
  //   path: '/carouselDetail/:id', // 轮播图详情
  //   name: 'carouselDetail',
  //   component: () => import('@/views/home/CarouselDetail')
  // },
  {
    path: '*', // 404页面
    name: 'notFound',
    component: () => import('@/views/nothingness/NotFound'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

export default router
